import { render, staticRenderFns } from "./training-category-table.vue?vue&type=template&id=78f2d7b7&"
import script from "./training-category-table.vue?vue&type=script&lang=js&"
export * from "./training-category-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports